(function () {
  var VIEW_ALL_URL = 'https://kctool.com/a/wysh';

  /* ── Toast ── */
  var toast = null;
  var toastTimer = null;

  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wysh-saved-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('visible');
    }, 2200);
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest('.wysh-list-dropdown-menu-item');
    if (!item) return;
    var icon = item.querySelector('.wysh-list-dropdown-icon');
    var isAdding = !icon || !icon.classList.contains('wysh-list-added-icon');
    var nameEl = item.querySelector('span:not([class])') || item.querySelector('span:last-child');
    var name = nameEl ? nameEl.textContent.trim() : 'wishlist';
    showToast(isAdding ? 'Saved to "' + name + '"' : 'Removed from "' + name + '"');
  });

  /* ── Share modal ── */
  var shareModal = null;

  function buildShareModal() {
    var overlay = document.createElement('div');
    overlay.className = 'wysh-share-overlay';

    var card = document.createElement('div');
    card.className = 'wysh-share-card';

    var header = document.createElement('div');
    header.className = 'wysh-share-header';

    var title = document.createElement('span');
    title.className = 'wysh-share-modal-title';
    title.textContent = 'Share Wishlist';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'wysh-share-close';
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', closeShareModal);

    header.appendChild(title);
    header.appendChild(closeBtn);

    var row = document.createElement('div');
    row.className = 'wysh-share-row';

    var input = document.createElement('input');
    input.className = 'wysh-share-input';
    input.type = 'text';
    input.readOnly = true;

    var copyBtn = document.createElement('button');
    copyBtn.className = 'wysh-share-copy-btn';
    copyBtn.textContent = 'Copy Link';
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(input.value).then(function () {
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = 'Copy Link'; }, 2000);
      });
    });

    row.appendChild(input);
    row.appendChild(copyBtn);
    card.appendChild(header);
    card.appendChild(row);
    overlay.appendChild(card);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeShareModal();
    });

    document.body.appendChild(overlay);
    shareModal = { overlay: overlay, input: input };
  }

  function openShareModal(url) {
    if (!shareModal) buildShareModal();
    shareModal.input.value = url;
    shareModal.overlay.classList.add('visible');
  }

  function closeShareModal() {
    if (shareModal) shareModal.overlay.classList.remove('visible');
  }

  // Capture phase fires before Wysh's bubbling handler — blocks the OS share sheet
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wysh-share-button');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openShareModal(btn.dataset.shareUrl || window.location.href);
  }, true);

  /* ── Product page wishlist button ── */
  function processButton(wyshBtn) {
    if (wyshBtn.dataset.wyshCustom) return;
    wyshBtn.dataset.wyshCustom = 'true';

    // Mark the button for CSS layout — do NOT move it in the DOM
    wyshBtn.classList.add('has-custom-wysh');

    var link = document.createElement('a');
    link.className = 'custom-wysh-view-all';
    link.href = VIEW_ALL_URL;
    link.textContent = 'View Wishlist';
    link.addEventListener('click', function (e) { e.stopPropagation(); });
    wyshBtn.appendChild(link);
  }

  function processAll() {
    document.querySelectorAll('.wysh-product-button:not([data-wysh-custom])').forEach(processButton);
  }

  new MutationObserver(processAll).observe(document.body, { childList: true, subtree: true });
  processAll();
})();
